// extracted by mini-css-extract-plugin
export default {"SettingsIcon":"SettingsIcon_SettingsIcon__E9Qan","alertContainer":"SettingsIcon_alertContainer__YBWVu"};